import SKUTab from './SKUTab';

export default SKUTab;
